import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const CompactNoTaskIcon = React.forwardRef((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    width="18px"
    height="18px"
    version="1.1"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <>
      <rect width="18" height="18" fill="none" />
      <path d="m9 0.5c-1.0896 0.0025906-2.052 0.71058-2.3789 1.75h-4.3711v13.5h13.5v-13.5h-4.3652c-0.32753-1.0415-1.293-1.75-2.3848-1.75zm0 1.5a1 1 0 0 1 1 1v0.75h4.25v10.5h-10.5v-10.5h4.25v-0.75a1 1 0 0 1 1-1zm-3.75 3.25v1.5h7.5v-1.5h-7.5zm0 3v1.5h7.5v-1.5h-7.5zm0 3v1.5h5.25v-1.5h-5.25z" />
    </>
  </SvgIcon>
));

export default CompactNoTaskIcon;
